/** Format a video timestamp as `m:ss.s` (e.g. `0:03.2`). */
export const formatVideoTime = (seconds: number): string => {
  const safe =
    Number.isFinite(seconds) && seconds > 0 ? Math.round(seconds * 10) / 10 : 0;
  const minutes = Math.floor(safe / 60);
  const remainder = safe - minutes * 60;
  return `${minutes}:${remainder.toFixed(1).padStart(4, '0')}`;
};
